import React from 'react';

export interface ReportStatusViewProps {
  title: string;
  message?: string;
  reportId?: string;
  variant?: 'loading' | 'error' | 'empty';
}

const TITLE_COLOR_BY_VARIANT: Record<NonNullable<ReportStatusViewProps['variant']>, string> = {
  loading: 'text-gray-600',
  error: 'text-red-600 font-semibold',
  empty: 'text-gray-600',
};

export const ReportStatusView: React.FC<ReportStatusViewProps> = ({
  title,
  message,
  reportId,
  variant = 'loading',
}) => (
  <div className="flex justify-center items-center min-h-screen bg-gray-50">
    <div className="text-center">
      <div className={`mb-2 ${TITLE_COLOR_BY_VARIANT[variant]}`}>{title}</div>
      {message && <div className="mb-2 text-gray-600">{message}</div>}
      {reportId && <div className="text-sm text-gray-400">ID: {reportId}</div>}
    </div>
  </div>
);
